/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  z as zod
} from 'zod'

/**
 * Retrieves the fee waiver config for a fund family
 */
export const feeWaiverConfigRetrieveParams = zod.object({
  "fundFamilyId": zod.string()
})

export const feeWaiverConfigRetrieveResponseAnnotationsSetMin = 2;
export const feeWaiverConfigRetrieveResponseAnnotationsSetMax = 2;export const feeWaiverConfigRetrieveResponseFeeWaiverCalculationsAnnotationsSetMin = 2;
export const feeWaiverConfigRetrieveResponseFeeWaiverCalculationsAnnotationsSetMax = 2;

export const feeWaiverConfigRetrieveResponse = zod.object({
  "annotations_set": zod.array(zod.array(zod.any()).min(feeWaiverConfigRetrieveResponseAnnotationsSetMin).max(feeWaiverConfigRetrieveResponseAnnotationsSetMax)).optional(),"is_enabled": zod.boolean().optional(),"start_date": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).or(zod.union([zod.null(), zod.literal("")])).optional(),"fee_waiver_calculation_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"fee_waiver_cap_calculation_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"fee_id": zod.string().min(1),"id": zod.string().min(1),"fee_waiver_calculations": zod.array( zod.object({
  "annotations_set": zod.array(zod.array(zod.any()).min(feeWaiverConfigRetrieveResponseFeeWaiverCalculationsAnnotationsSetMin).max(feeWaiverConfigRetrieveResponseFeeWaiverCalculationsAnnotationsSetMax)).optional(),"id": zod.string().min(1).optional(),"fee_waiver_calculation_id": zod.string().min(1),"fund_entity_id": zod.string().min(1),"fee_waiver_config_id": zod.string().min(1)
}))
})

/**
 * Edits a fee waiver config
 */
export const feeWaiverConfigUpdateParams = zod.object({
  "fundFamilyId": zod.string()
})

export const feeWaiverConfigUpdateBody = zod.object({
  "id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"is_enabled": zod.boolean().optional(),"start_date": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).or(zod.union([zod.null(), zod.literal("")])).optional(),"fee_waiver_calculation_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"fee_waiver_cap_calculation_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"fee_waiver_calculations": zod.array( zod.object({
  "id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"fee_waiver_calculation_id": zod.string().min(1),"fund_entity_id": zod.string().min(1)
})).optional()
})

export const feeWaiverConfigUpdateResponseAnnotationsSetMin = 2;
export const feeWaiverConfigUpdateResponseAnnotationsSetMax = 2;

export const feeWaiverConfigUpdateResponse = zod.object({
  "annotations_set": zod.array(zod.array(zod.any()).min(feeWaiverConfigUpdateResponseAnnotationsSetMin).max(feeWaiverConfigUpdateResponseAnnotationsSetMax)).optional(),"is_enabled": zod.boolean().optional(),"start_date": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).or(zod.union([zod.null(), zod.literal("")])).optional(),"fee_waiver_calculation_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"fee_waiver_cap_calculation_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"fee_id": zod.string().min(1),"id": zod.string().min(1)
})

